// --------------------------------------------------------------------------
// Account Login (part of #235 Contact Details)
// --------------------------------------------------------------------------
// Author:      Mike Simmonds, Alix Richards
// Email:       frontend@zonedigital.com
// URL:         https://www.zonedigital.com/
// Copyright:   Copyright (c) 2017, zonedigital.com. All rights reserved.
// Version:     1.0.0
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');
var reinitModules = require('../../utilities/reinit-modules');

// jquery plugins
require('../../plugins/jquery.validate');
require('../../plugins/jquery.validate.unobtrusive');

module.exports = function (options) {
    var context = options.context;
    var wrapper = context.find('[data-name="contact-details"]');
    var form = context.find('form');
    var currentUrl = context.find('#CurrentPageUrl');
    var $modalContent = context.find('[data-binding="modal"]');
    var $modalOverlay = context.find('[data-name="modal-overlay"]');
    var $modelTrigger = context.find('[data-binding="open-modal"]');
    var $modalFields = $modalContent.find('input, select, textarea').addClass('ignore-field');
    var inactive = 'inactive';
    var $body = $('body');
    var isModalOpen = false;
    var formValid = false;

    /// Init function from app.js
    function reinitialiseModules() {
        var modules = [{
            name: 'form-address',
            module: require('../../modules/form-address')
        }];
        reinitModules(modules);
    }

    /// Ignore fields with class 'ignore-field'
    $.validator.setDefaults({
        ignore: ':hidden, .ignore-field'
    });

    $.validator.unobtrusive.parse(form);

    function resetFormValidation() {
        form.removeData('validator');
        form.removeData('unobtrusiveValidation');
        form.find('.input-validation-error').removeClass('input-validation-error').addClass('valid');
        $modalContent.find('.validation-summary-errors').removeClass('validation-summary-errors').addClass('validation-summary-valid');
        form.find('.field-validation-error').removeClass('field-validation-error').addClass('field-validation-valid').empty();
        $.validator.unobtrusive.parse(form);
    }

    function openModal() {
        /// Open modal
        $modelTrigger.on('click', function (event) {
            event.preventDefault();

            /// Ignore main form fields, don't ignore ones in modal
            form.find('input, select, textarea').not($modalFields).addClass('ignore-field');
            $modalFields.removeClass('ignore-field');

            /// Update validation
            resetFormValidation();

            /// Show modal
            $modalContent.removeClass(inactive);
            $modalOverlay.removeClass(inactive);
            $body.addClass('no-scroll');
            isModalOpen = true;

            /// Focus first field - check if this is working
            ///$modalFields.first().focus();
        });
    }

    function closeModal() {
        /// Close modal
        context.on('click', '[data-binding="account-login-cancel"]', function (event) {
            event.preventDefault();

            /// Ignore modal fields, don't ignore main form fields
            form.find('input, select, textarea').not($modalFields).removeClass('ignore-field');
            $modalFields.addClass('ignore-field');

            /// Clear modal form fields
            $modalContent.find('input').val('');

            /// Update validation
            resetFormValidation();

            /// Hide modal
            $modalContent.addClass(inactive);
            $modalOverlay.addClass(inactive);
            $body.removeClass('no-scroll');
            isModalOpen = false;
        });
    }

    function ajaxThings(donationForm) {

        // We need to take care to serialize and post only non-card related fields (they all have a prefix of 'x_')
        var serializedFormData = $('[name]:not([name^="x_"])', donationForm).serialize();

        $.ajax({
            data: serializedFormData + '&' + 'ContactDetailsLogin=',
            type: 'POST',
            url: !currentUrl || 0 === currentUrl.length ? donationForm.attr('action') : currentUrl.val(),
            success: function success(data) {

                // Response is a simple success flag.
                // On successful response, reload the page.
                // On error, display failed login message.
                if (data.success) {
                    location.reload(true);
                } else {
                    $modalContent.find('.validation-summary > div').addClass("validation-summary-errors").removeClass("validation-summary-valid").find('ul').empty().append('<li>' + data.message + '</li>');
                }
            }
        });
    }

    function isFormValid(donationForm) {
        var inputError = context.find('.input-validation-error').length;
        var errorCount = parseInt(inputError);

        if (errorCount === 0) {
            formValid = true;
            ajaxThings(donationForm);
        }
    }

    function bindings() {
        openModal();
        closeModal();

        var donationForm = context.find('form');

        donationForm.on('submit', function (e) {

            if (isModalOpen) {
                e.preventDefault();
                isFormValid(donationForm);
                donationForm.trigger('reset-submit');
            } else {
                return;
            }
        });
    }

    function init() {
        /**
         * As with form-toggle.js,
         * we need to wait until the document is 'ready', as this behavior may be
         * initialised before jQuery.validate(), making the latter undefined if used
         */
        $(document).ready(function () {
            bindings();
        });
    }

    return {
        init: init
    };
};

//     // If form is invalid, exit
//     //if (!form.valid()) return;


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/forms/account-login.js
// module id = 278
// module chunks = 0